import { render } from "./dashboard.html?vue&type=template&id=0d688a8e&ts=true&external"
import script from "./dashboard.ts?vue&type=script&lang=ts&external"
export * from "./dashboard.ts?vue&type=script&lang=ts&external"

import "./dashboard.scss?vue&type=style&index=0&lang=scss&external"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__